import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import './app-store.less';
import { AppStoreControllerModule } from './controllers/AppStoreController';

export const AppStoreView = angular
  .module('acme.view.application.app-store', [uiRouter, 'ui.bootstrap', AppStoreControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.app-store',
      url: '/integration-and-apps?appId',
      views: {
        'subview-main': {
          controller: 'AppStoreController',
          templateUrl: 'views/application/views/app-store/app-store.tpl.html',
        },
      },
      resolve: {
        AppStore: () => import('@peekops/app-store/extentions/assets/ext/app-store.min.js'),
      },
      data: {
        pageTitle: 'Integration & Apps',
        permissions: ['APP_ADMIN'],
        featureFlags: ['enableAppsIntegration'],
      },
    });
  }).name;
